import React from 'react';

import classNames from 'classnames';
import { withStyles, makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
    root: {
        display: 'flex',
        flex: '1 1 auto',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: theme.spacing(),
    },
    withLeft: {
        justifyContent: 'space-between',
    },
});

const buttonStyles = makeStyles(theme => ({
    root: {
        marginRight: theme.spacing(2),

        '&:last-child': {
            marginRight: 0,
        },
    },
    progress: {
        marginLeft: 10,
    },
    buttonWithProgess: {
        minWidth: 100,
    },
}));

const Buttons = ({ classes, withLeft = false, children }) => {
    const className = classNames({
        [classes.root]: true,
        [classes.withLeft]: withLeft,
    });
    return <div className={className}>{children}</div>;
};

Buttons.Secondary = ({ variant, autoFocus, disabled, onClick, label }) => {
    const classes = buttonStyles();
    return (
        <Button
            className={classes.root}
            onClick={onClick}
            variant={variant}
            color="primary"
            autoFocus={autoFocus}
            disabled={disabled}
        >
            {label}
        </Button>
    );
};

Buttons.Primary = ({
    variant,
    autoFocus,
    disabled,
    onClick,
    label,
    loading,
}) => {
    const classes = buttonStyles();
    return (
        <Button
            className={classNames(classes.root, {
                [classes.buttonWithProgess]: loading,
            })}
            onClick={onClick}
            variant={variant}
            color="secondary"
            autoFocus={autoFocus}
            disabled={loading || disabled}
        >
            {label}
            {loading && (
                <CircularProgress size={12} className={classes.progress} />
            )}
        </Button>
    );
};

export default withStyles(styles)(Buttons);
